import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {deviceGroupActions} from "../../../../actions/device-group.actions";
import {networkDeviceActions} from "../../../../actions/network-device.actions";
import MultiselectTwoSides from "react-multiselect-two-sides";
import {Button, Spinner} from "react-bootstrap";

class DeviceGroupAssignToGroupForm extends Component {

    state = {
        options: [],
        value: []
    };

    componentDidMount() {
        const { dispatch, data } = this.props;
        dispatch(networkDeviceActions.getNetworkDeviceList());
        dispatch(deviceGroupActions.getDeviceGroupById(data.id));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.deviceList !== prevProps.deviceList) {
            const deviceListMap = this.props.deviceList ?
                Array.from(this.props.deviceList, x => { return {name: x.label, value: x.id} }):
                [];

            this.setState({
                ...this.state,
                options: deviceListMap
            });
        }

        if(this.props.singleItem !== prevProps.singleItem) {
            const ids = this.props.singleItem?.networkDevices ?
                Array.from(this.props.singleItem.networkDevices, x => x.id):
                [];

            this.setState({
                ...this.state,
                value: ids
            });
        }
    }

    handleChange = (value) => {
        this.setState({value});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { dispatch, deviceList, singleItem } = this.props;
        const networkDeviceList = deviceList.filter((args) => args.id === this.state.value.find(id => id === args.id));
        dispatch(deviceGroupActions.assignDeviceToGroup(singleItem.id, networkDeviceList));
    };

    render() {
        const { t, singleItem } = this.props;
        const { options, value } = this.state;
        const selectedCount = value.length;
        const availableCount = options.length - selectedCount;

        return (
            <React.Fragment>
                { options.length > 0 ?  (
                        <MultiselectTwoSides
                            {...this.state}
                            className="msts_theme_example"
                            onChange={this.handleChange}
                            availableHeader={t('network-devices')}
                            availableFooter={`Available: ${availableCount}`}
                            selectedHeader={singleItem?.label}
                            selectedFooter={`Selected: ${selectedCount}`}
                            labelKey="name"
                            searchable
                        />
                ) : ( <Spinner animation={"grow"}/> )}

                <div className="form-group py-4 text-right">
                    <Button variant={"success"} type={"button"} onClick={this.handleSubmit}>
                        <i className="fas fa-plus-circle"/> &nbsp; {t('save-changes')}
                    </Button>
                </div>

            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    const { singleItem } = state.deviceGroupReducer;
    const { list } = state.networkDeviceReducer;
    return {
        singleItem,
        deviceList: list
    }
};
export default withNamespaces()(connect(mapStateToProps)(DeviceGroupAssignToGroupForm))
